import { ComponentChildren } from 'preact';

type WizardFooterProps = {
  children: ComponentChildren;
  className?: string;
  show?: boolean;
};

export function WizardFooter({ children, className = '', show = true }: WizardFooterProps) {
  if (!show) {
    return null;
  }

  return (
    <footer
      class={`sticky bottom-0 bg-white border-t border-gray-100 -mx-8 px-8 py-6 mt-6 ${className}`}
    >
      {children}
    </footer>
  );
}
